import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError, map } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ChatRequest, ChatResponse } from '../models/chatbot.model';

@Injectable({
  providedIn: 'root'
})
export class ChatbotService {
  private http = inject(HttpClient);
  private chatbotUrl = environment.chatbotUrl;

  /**
   * Envía una pregunta al chatbot y obtiene la respuesta
   * @param question La pregunta del usuario
   * @param conversationId ID opcional de la conversación para mantener contexto
   * @returns Observable con la respuesta del chatbot
   */
  sendQuestion(question: string, conversationId?: string): Observable<ChatResponse> {
    const request: ChatRequest = {
      question
    };

    return this.http.post<ChatResponse>(`${this.chatbotUrl}/api/bot/chat`, request).pipe(
      map(response => ({
        success: response.success,
        message: response.message,
        conversationId: response.conversationId,
        documents_used: response.documents_used,
        timestamp: response.timestamp
      })),
      catchError((error) => {
        console.error('[ChatbotService] POST chat request failed', error);
        return throwError(() => error);
      })
    );
  }

  /**
   * Inicia una nueva conversación con el chatbot
   * @returns Observable con el ID de la nueva conversación
   */
  startNewConversation(): Observable<{ conversationId: string }> {
    return this.http.post<{ conversationId: string }>(`${this.chatbotUrl}/chat/new`, {}).pipe(
      catchError((error) => {
        console.error('[ChatbotService] POST new conversation failed', error);
        return throwError(() => error);
      })
    );
  }

  /**
   * Obtiene el historial de una conversación
   * @param conversationId ID de la conversación
   * @returns Observable con el historial de mensajes
   */
  getConversationHistory(conversationId: string): Observable<ChatResponse[]> {
    return this.http.get<ChatResponse[]>(`${this.chatbotUrl}/chat/history/${conversationId}`).pipe(
      catchError((error) => {
        console.error('[ChatbotService] GET conversation history failed', error);
        return throwError(() => error);
      })
    );
  }
}
